import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { EventsApi } from '../../../api/events/events-api';
import { EventQueryApiModel } from '../../../api/events/models/event.query.api.model';
import { UserEventModel } from '../../../api/events/models/user-event.model';

@Injectable()
export class EventsService {

    constructor(
        private eventsApi: EventsApi
    ) {}

    public searchMine(query: EventQueryApiModel): Observable<UserEventModel[]> {

        return this.eventsApi.searchMine(query).pipe(
            map(events => events.map(eventApiModel => new UserEventModel(eventApiModel)))
        );
    }
}
